export default "__VITE_ASSET__DpUW$f1$__"